import { useQuery } from '@tanstack/react-query';
import { AUTH_SESSION_QUERY_KEY } from '../constants';
import { readStoredSession } from '../lib/authSessionStorage';
import type { SignInResponse } from '../types/auth';

export function useAuthSession() {
  return useQuery({
    queryKey: AUTH_SESSION_QUERY_KEY,
    queryFn: async (): Promise<SignInResponse | null> =>
      Promise.resolve(readStoredSession()),
    staleTime: Infinity,
    gcTime: Infinity,
  });
}

export function isAuthenticatedSession(
  data: SignInResponse | null | undefined,
): data is SignInResponse {
  return Boolean(
    data?.success && data.data?.accessToken && data.data?.user?.userId,
  );
}
